module.exports = __webpack_public_path__ + "img/main_header1.74fa8c9d.svg";